var styles = {"fontElementMap":"_3UI77","orderedlist":"f9R64","bulletedlist":"w1FsT","listItem":"PMieU"};

export { styles as s };
//# sourceMappingURL=lists-7ee1a3fb.js.map
